import { Outlet, Link } from 'react-router-dom';

export default function Layout() {
  return (
    <div className="min-h-screen w-full bg-white relative flex flex-col items-center overflow-x-hidden font-sans">
      
      {/* Header Navigasi Atas */}
      <header className="w-full flex justify-between items-center p-6 max-w-5xl mx-auto z-20 bg-white">
        <div className="flex items-center">
          <img src="/logo.png" alt="Fabric Foundation" className="h-10 md:h-12 w-auto object-contain" />
        </div>
        <nav className="flex gap-6 font-semibold text-gray-500 text-sm md:text-base">
          <Link to="/" className="text-black font-bold">Claim</Link>
          <Link to="/swap" className="hover:text-black transition-colors">Bridge</Link>
        </nav>
      </header>

      {/* Banner Deposit (Logo menggunakan SVG Lokal) */}
      <div className="w-full bg-gradient-to-r from-pink-100 via-purple-50 to-cyan-100 border-y border-white/50 py-3 flex justify-center items-center gap-2 md:gap-4 text-xs md:text-sm font-semibold text-gray-600 z-20 shadow-sm">
         <span>Deposit your $ROBO now at</span>
         <div className="flex items-center gap-1.5 text-black">
           <img src="/binance.svg" alt="Binance Web3" className="w-4 h-4 md:w-5 md:h-5 object-contain" /> Binance Web3
         </div>
         <span className="text-gray-400 font-bold">OR</span>
         <div className="flex items-center gap-1.5 text-black">
           <img src="/bitget.svg" alt="Bitget" className="w-4 h-4 md:w-5 md:h-5 object-contain" /> Bitget
         </div>
      </div>

      {/* Kontainer Utama */}
      <div className="w-full max-w-xl relative z-10 p-4 mt-6 md:mt-10 mb-20">
        <Outlet />
      </div>
    </div>
  );
}